import { orange } from "../../theme/colors";

export default function RequiredMark() {
  return <span style={{ color: orange }}>*</span>;
}
